import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { counties } from "./constants/counties";
import { countyFormatter } from "./utils/countyFormatter";
import { Controller, FieldError, UseFormMethods } from "react-hook-form";
import { alphaNumericRegex } from "itsf-ui-common";

interface ICounties {
    control: UseFormMethods["control"];
    error: FieldError | undefined;
    isDisabled: boolean;
    prefix?: string;
    clearEircode(): void;
}

export const CountiesDropdown = (props: ICounties) => {
    const { t } = useTranslation(["address", "validation"]);
    const { control, error, isDisabled, clearEircode, prefix } = props;

    const namePrefix = prefix ? `${prefix}.` : "";
    const idPrefix = prefix ? `${prefix}-` : "";

    const countiesList = counties.map((county) => ({ value: county, label: countyFormatter(county) }));

    return (
        <Controller
            control={control}
            name={`${namePrefix}county`}
            render={(renderProps) => (
                <TextField
                    className="xtest_title_input"
                    disabled={isDisabled}
                    error={Boolean(error)}
                    fullWidth
                    helperText={error?.message}
                    id={`${idPrefix}counties`}
                    inputRef={renderProps.ref}
                    label={`${t("address:county")} *`}
                    margin="dense"
                    name={renderProps.name}
                    select
                    value={renderProps.value}
                    variant="standard"
                    onChange={(event) => {
                        clearEircode();

                        return renderProps.onChange(event);
                    }}
                >
                    {countiesList.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            )}
            rules={{
                required: t("validation:required"),
                pattern: { value: alphaNumericRegex, message: t("validation:onlyLettersNumbers") },
            }}
        />
    );
};
